import {OutBoundsActionType} from "../../actions/outbounds/outboundsAction";
import {ReportsActionType} from "../../actions";
import { v4 as uuidv4 } from 'uuid';

const DefaultReportsState = {
    agingList:[],
    total:0,
    skuList:[],
    batchList:[],
    expireList:[],
    locationList:[],
    asnList:[],
    requisitionList:[],
    invoiceList:[],
    invoiceInfo:{},
    invoiceDownloadInfo:{
        summaryList:[],
        detailByWarehouseList:[],
        detailByDateList:[],
    },
    otherFeeList:[],
    otherFeeInfo: {},
    storageFeeList:[],
    businessTypeList:[],
    summaryList:[],
    individualList:[],
    warehouseAreaList:[],
    saleSkuList:[],
    saleCustomerList:[],
    saleBatchList:[],
    costInfoList:[],
    costDetailsList:[],
    nonCanadianShippingList:[],
    nonCanadianShippingOwnerList:[],
    itemList:[],
    costDetailsItemTotal:0,
    costDetailsItemList:[]
}

const moveManualAfterOther = (list = []) => {
    const other = list.find(i => i.dictLabel === "Other");
    const manual = list.find(i => i.dictLabel === "Otherfee-Manual");

    if (!other || !manual) return list;

    return [
        ...list.filter(i => i.dictLabel !== "Otherfee-Manual"),
    ].flatMap(item =>
        item.dictLabel === "Other"
            ? [item, manual]
            : [item]
    );
};

export const reportsReducer = ( state = DefaultReportsState, action = {}) =>
{
    switch (action.type) {
        case ReportsActionType.Aging_List:
            return { ...state, agingList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.SKU_List:
            return { ...state, skuList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Batch_List:
            return { ...state, batchList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Expire_List:
            return { ...state, expireList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Location_List:
            return { ...state, locationList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.ASN_List:
            return { ...state, asnList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Requisition_List:
            return { ...state, requisitionList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}

        case ReportsActionType.Invoice_Item_Detail:
            return {
                ...state,itemList: action.payload.invoiceDetailParams? action?.payload?.invoiceDetailParams.map((item, index) => {
                    return { ...item, id: uuidv4() };
                }):[], total: (action?.payload?.info?.qtyReceiveApply)?(action?.payload?.info?.qtyReceiveApply):0,
                invoiceInfo:action?.payload
            }
        case ReportsActionType.Invoice_List:
            return { ...state, invoiceList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Invoice_Info:
            return { ...state, invoiceInfo:action.payload}
        case ReportsActionType.Reset_Invoice:
            return { ...state, invoiceInfo:{}}
        case ReportsActionType.Invoice_Download_Info:
            return { ...state, invoiceDownloadInfo:action.payload}

        case ReportsActionType.Reset_Invoice_Download_Info:
            return { ...state, invoiceDownloadInfo:{
                        summaryList:[],
                        detailByWarehouseList:[],
                        detailByDateList:[],
                }}

        case ReportsActionType.Other_Fee_List:
            return { ...state, otherFeeList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() };
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Other_Fee_Info:
            return { ...state, otherFeeInfo:action.payload}
        case ReportsActionType.Reset_Other_Fee:
            return { ...state, otherFeeInfo:{}}

        case ReportsActionType.Storage_Fee_List:
            return { ...state, storageFeeList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() };
                }):[], total: action.payload.total?action.payload.total:0}


        case ReportsActionType.Non_Canadian_Shipping_List:
            return { ...state, nonCanadianShippingList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}

        case ReportsActionType.Non_Canadian_Shipping_Owner_List:
            return { ...state, nonCanadianShippingOwnerList: action.payload.data}





        case ReportsActionType.BusinessTypeList:
            return {...state,businessTypeList: moveManualAfterOther(action.payload)}
        case ReportsActionType.Summary_List:
            return { ...state, summaryList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Individual_List:
            return { ...state, individualList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}

        case ReportsActionType.Warehouse_List:
            return { ...state, warehouseAreaList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}

        case ReportsActionType.Sale_SKU_List:
            return { ...state, saleSkuList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case ReportsActionType.Sale_Customer_List:
            return { ...state, saleCustomerList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}

        case ReportsActionType.Sale_Batch_List:
            return { ...state, saleBatchList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}

        case ReportsActionType.Cost_Details_List:
            return { ...state, costDetailsList: action.payload.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}

        case ReportsActionType.Cost_Details_List_Info:
            return {
                ...state,costDetailsItemList: action.payload?.details? action?.payload?.details.map((item, index) => {
                    return { ...item, id: uuidv4() };
                }):[], costDetailsItemTotal: (action?.payload?.info?.qtyReceiveApply)?(action?.payload?.info?.qtyReceiveApply):0
            }

        case ReportsActionType.Cost_Info_List:
            return {
                ...state,
                costInfoList: action.payload?.fulfillmentCosts ? action.payload?.fulfillmentCosts.map((item, index) => {
                    if (item.fulfillCostName === 'Handing Fee') {
                        item.fulfillCostName = 'Operation Fee'
                    }
                    if (item.fulfillCostName === 'Shipping Fee') {
                        item.fulfillCostName = 'Delivery Fee'
                    }
                    return {...item, id: uuidv4()}; // 使用展开语法创建新对象，并添加ID属性
                }) : [],
                total: action?.payload?.fulfillmentCosts?.length | 0
            }
        default:
            return state;

    }

}